"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRandomBitstraySeed = exports.getBitstrayData = exports.ImageData = void 0;
var image_data_json_1 = require("./image-data.json");
Object.defineProperty(exports, "ImageData", { enumerable: true, get: function () { return __importDefault(image_data_json_1).default; } });
var utils_1 = require("./utils");
Object.defineProperty(exports, "getBitstrayData", { enumerable: true, get: function () { return utils_1.getBitstrayData; } });
Object.defineProperty(exports, "getRandomBitstraySeed", { enumerable: true, get: function () { return utils_1.getRandomBitstraySeed; } });
